
enum Certificate {
    UNKNOWN = -1,
    FIRST = 0,
    PROLONGATION = 1,
    RELAPSE = 2
}

export default Certificate;